module.exports = __webpack_public_path__ + "static/media/S1N7-1.5a9f7b78.svg";